<template>
	<div>
		<b-modal v-model="mostrar_factura" ref="modalGenerarFactura" size="xl" centered header-bg-variant="dark" header-text-variant="light">
		    <template #modal-header=""><h5>{{ getTitulo }}</h5></template>
			<template #default="">
				<div class="alert alert-primary">Ingrese los montos por cada R.U.T. asociados a la empresa matriz, al que desea cargar el monto total o parcial de la factura original.</div>
				<b-form id="refacturarForm">
					<div style="max-height: 180px; overflow: auto">
						<div class="ingresa-monto" v-for="(cliente, index) in getClientes" :key="index" :id="cliente._id">
							<ingresa-monto :cliente="cliente" :agregar="true"
								@evento-agregar-campo="onClickAgregarCampoEvent"
								@evento-eliminar-campo="onClickEliminarCampoEvent"
								@evento-agregar-glosa="onClickAgregarGlosaEvent">
							</ingresa-monto>
						</div>
					</div>
					<p></p>
					<div class="row">
						<div class="col-md-12">
							<b-input-group size="sm" prepend="Fecha de Emisión NC">
								<date-picker id="fecha_emision_nc" name="fecha_emision_nc" v-model="fecha_emision_nc"
									:config="{ format: 'DD/MM/YYYY', locale: 'es' }" placeholder="Ingresar Fecha" required>
								</date-picker>
							</b-input-group>
						</div>
					</div>
					<p></p>
					<div class="row">
						<div class="col-md-12">
							<b-input-group size="sm" prepend="Total NC">
								<b-form-input id="total_nc" name="total_nc" size="sm" class="text-right" :value="getTotalNC(false)" disabled />
							</b-input-group>
						</div>
					</div>
					<p></p>
					<div class="row">
						<div class="col-md-12">
							<b-input-group size="sm" prepend="Total desgloce">
								<b-form-input id="total_desglose" name="total_desglose" size="sm" class="text-right" :value="getTotalDesglose(false)" disabled />
							</b-input-group>
						</div>
					</div>
					<p></p>
					<div class="row">
						<div class="col-md-12">
							<b-input-group size="sm" :prepend="'Total Folio: ' + documento.number">
								<b-form-input id="total_folio" name="total_folio" class="text-right" :value="getTotalFolio(false)" disabled />
							</b-input-group>
						</div>
					</div>
					<p></p>
					<div class="row">
						<div class="input-group col-md-12">
							<b-input-group size="sm" prepend="Total Pendiente">
								<b-form-input id="total_pendiente" name="total_pendiente" class="text-right" :value="getTotalPendiente(false)" disabled />
							</b-input-group>
						</div>
					</div>
				</b-form>
				<p></p>
				<b-alert :show="mostrar_alerta" dismissible :variant="variant" class="text-center" @dismissed="mostrar_alerta=false"><h6>{{ mensaje }}</h6></b-alert>
			</template>
			<template #modal-footer="">
				<b-button size="sm" variant="success" @click="refacturar" :disabled="disabled">Refacturar</b-button>
				<b-button size="sm" variant="secondary" @click="cerrarGenerarFactura">Cerrar</b-button>
			</template>
		</b-modal>
		<agregar-glosa v-if="mostrar_agregar_glosa" 
			:cliente="cliente" :id="id_agregar_glosa" :tipo="documento.tipoDocumento" :factura="factura"
			:on-cerrar="onCerrarAgregarGlosa"
			:on-agregar="onAgregarGlosa"></agregar-glosa>
	</div>
</template>
<script lang="ts">

	import Vue from "vue"
	import axios from "axios"
	import { uuid } from "vue-uuid"
	import $ from "jquery"
	import moment from "moment"
	import IngresaMonto from "./ingresa_monto.vue"
	import AgregarGlosa from "./agregar_glosa.vue"


	export default {
		name: "GenerarFactura",
		components: { IngresaMonto, AgregarGlosa },
		props: {
			documento: Object, // Objeto con la informacion del documento a refacturar
			onCerrar: Function,
		},
		data() {
			return {
				clientes: {}, // Estructura con la info de todos los clientes asociados
				ncs: {}, // Estructura con las notas de crédito asociadas al documento
				mostrar_factura: false, // Flag que controla si se muestra o no la ventana "Refacturacion"
				mostrar_agregar_glosa: false, // Flag que controla si se muestra o no la ventana "Agregar Glosa"
				mostrar_alerta: false, // Flag que controla cuando mostrar el alerta "Monto no Facturable"
				cliente: {}, // Estructura con los datos del cliente seleccionado 
				id_agregar_glosa: "", // ID que relaciona la ventana "Agregar Glosa" con el "Ingresa Monto" para poder actualizar el campo Monto
				facturas: [], // Arreglo que guarda las facturas que se van creando
				factura: {}, // Objeto con los datos de la factura asociada al cliente
				fecha_emision_nc: "",
				total_nc: 0,
				total_desglose: 0,
				total_folio: 0,
				total_pendiente: 0,
				variant: "",
				mensaje: "",
				disabled: false
			}
		},
        created() {

			this.getNCsAsociadas()
			this.total_folio = this.documento.totalAmount

			if (this.factura != undefined)
				this.fecha_emision = ""
		},
		mounted: function() {

			this.getClienteData()
		},
		computed: {

			getTitulo() {

				return "REFACTURACION DE FOLIO: " + this.documento.number 
            },

			getClientes() {

				return this.clientes
			},

			// Devuelve un guid para los componentes referencia y glosa (el primero de la lista, que no se puede borrar)
			getId() {

				return uuid.v1()
			},
        },
		methods: {

			getNCs() {

                // Request para la llamada
				var request = {
					"usuario": this.$usuario,
					"destino": this.$env,
					"tx": "D0",
					"operacion": "findNCs",
					"data2query": {
						"id_factura": this.documento.factura_id_bsale
					}
				}

				return axios.post("/face", request, { headers: { "Content-Type": "text/plain" } }).then((response) => {
					return response
				})
			},

			// Obtenemos las Notas de Créditos asociadas al documento
			getNCsAsociadas() {

				this.getNCs().then((response) => {

					if (response.data.datos !== undefined)
						this.ncs = response.data.datos

					Object.keys(this.ncs).forEach(key => {
						this.total_nc += this.ncs[key].NC_monto
					})

					this.total_pendiente = this.total_folio - this.total_nc

					if (this.total_nc == this.total_folio)
					{
						this.variant = "danger"
						this.mensaje = "Error Documento Anulado"
						this.mostrar_alerta = true
						this.disabled = true
					}
				})
			},

			// Leemos los datos del RUT y los guardamos en la variable "clientes"
			getClienteData() {

				// Mostramos la imagen cargando
				window.event.$emit("mostrar-cargando", true)

				var rut = this.documento.code.toString().replace(/[. ]/g, "")

                // Llamamos a la API 
				var request = {
					"usuario": this.$usuario,
					"destino": this.$env,
					"tx": "D0",
					"operacion": "clientTree",
					"cliente": { "CLIENT_TAX_CODE": rut },
				}

				axios.post("/face", request, { headers: { "Content-Type": "text/plain" } }).then(response => {

					var data = response.data
					if (data.estatus !== undefined)
					{
						this.clientes = data.data
						this.mostrar_factura = true
					}

					// Ocultamos la imagen cargando
					window.event.$emit("mostrar-cargando", false)

				}).catch(ex => { 

					// Si hubo un error en la llamada, pasamos por aca
					console.log(ex.message) 

					// Ocultamos la imagen cargando
					window.event.$emit("mostrar-cargando", false)
				})

			},

			// Si se cierra la ventana Generar Factura, se cambia el valor de la variable para que no se muestre,
			// y se avisa al componente padre a traves del evento "evento-cerrar-generar-factura" para que no cree el objeto al refrescar el DOM
			cerrarGenerarFactura() {

				this.mostrar_factura = false

				// Llamamos a la funcion callback asociada a la accion de cerrar la ventana
				if (this.onCerrar)
					this.onCerrar(this.mostrar_factura)
			},

			// Se asume que al presionar Refacturar, se cierra la ventana
			refacturar() {
				
				$("#fecha_emision_nc").removeClass("is-invalid")
				if (this.fecha_emision_nc == "") 
				{
					$("#fecha_emision_nc").addClass("is-invalid")
					return
				}

				// Si el monto de las facturas es 0, se muestra el mensaje "Monto no facturable"
				if (this.total_desglose == 0)
				{
					this.mensaje = "Monto no Facturable"
					this.variant = "danger"
					this.mostrar_alerta = true

					return
				}

				this.disabled = true

				// Recorremos todas las facturas ingresadas para armar la estructura que enviaremos al REST
				var docs_nuevos = []
				for (var f of this.facturas)
				{
					// Buscamos la info del cliente de la factura
					var cliente = this.buscarCliente(f._id)
					
					// Recorremos las glosas de la factura, para agregar el ID del cliente (requisito???) en el comentario
					f.glosas.forEach(function(g, i) {

						var comment = g.comment + " [[ " + (cliente._source.CLIENT_ID != "" ? cliente._source.CLIENT_ID : cliente._source.CLIENT_ID_MADRE) + " ]]"

						f.glosas[i].comment = comment
					})

					// Fecha de Vencimiento del documento
					var fecha_vcto = moment().format('X')  > this.documento.expiration_date ? f.fecha_emision : this.documento.expiration_date

					// Objeto temporal donde guardaremos la info de la factura
					var tmp = {
						cliente: cliente, 
						ES_id_of: this.documento.number,
						emissionDate: f.fecha_emision,
						expirationDate: fecha_vcto,
						references: f.referencias,
						details: f.glosas,
						total_fac: f.total_fac,
						iva: f.iva
					}

					docs_nuevos.push(tmp)
				}

				var f = this.fecha_emision_nc.split("/")
				var fecha_emision = moment(f[2] + "-" + f[1] + "-" + f[0] + "T00:00:00+00:00").format("X")

				// Parametros para enviar al rest
				var request = {
					usuario: this.$usuario,
					destino: this.$env,
					tx: "f1",
					operacion: "dte_rf",
					doc_original: this.documento,
					docs_nuevos: docs_nuevos,
					ES_id_of: this.documento.number,
					modifications: {
						nc_emissionDate: fecha_emision,
						nc_priceAdjustment: 1,
						nc_unitValue: this.documento.netAmount - this.total_nc,
						nc_editTexts: 0,
						nc_quantity: 1,
						nc_motive: "Anula documento"
					}
				}

				// Tenemos toda la info, llamamos al rest para enviarla al servidor
				axios.post("/face", request, { headers: { "Content-Type": "text/plain" } }).then(response => {

					this.variant = "success";
					if(response.data.estatus!==undefined){
						if(response.data.estatus==="NO OK"){
							this.mensaje = response.data.error;
						}
						else{
							this.mensaje = "Proceso finalizado con éxito"
						}
					}
					else{
						this.mensaje = "Proceso finalizado con éxito"
					}
					
					this.mostrar_alerta = true
				}).catch(ex => {

					this.variant = "danger";
					this.mensaje = ex.message
					this.mostrar_alerta = true
				})
			},

			// Buscamos los datos del cliente en el arreglo de clientes, segun el id 
			buscarCliente(id) {

				var cliente = {}
				this.clientes.forEach(function(c) {

					if (c._id == id)
					{   
						cliente = c
						return false
					}
				})


				return cliente
			},

			// Buscamos los datos del cliente en el arreglo de clientes, segun el id 
			buscarFactura(id) {

				var factura = {}
				this.facturas.forEach(function(f) {

					if (f.cid == id)
					{   
						factura = f
						return false
					}
				})


				return factura
			},

			// Buscamos la factura por su ID y la eliminamos de la lista
			eliminarFactura(id) {

				var idx = -1
				this.facturas.forEach(function(f, i) {

					if (f.cid == id)
					{
						idx = i
						return false
					}
				})

				if (idx > -1)
					this.facturas.splice(idx, 1)
			},

			// Calcula los totales cuando se hayan ingresado facturas nuevas
			calculaTotales() {

				// Si hay facturas, entonces calculamos
				if (this.facturas.length > 0)
				{
					// Primero sumamos todoas las facturas
					var total_desglose = 0
					this.facturas.forEach(function(f) {
						
						total_desglose += f.total_fac
					})
	
					// Si el monto de las facturas es 0, se muestra el mensaje "Monto no facturable"
					if (total_desglose == 0)
						this.mostrar_alerta = true
	
					this.total_desglose = total_desglose

					// Calculamos la diferencia por facturar
					this.total_pendiente = this.total_folio - this.total_nc - this.total_desglose
				}
			},

			getTotalNC(iva) {

				return !iva ? Intl.NumberFormat("es-CL").format(this.total_nc) : Intl.NumberFormat("es-CL").format(this.total_nc_iva)
			},

			getTotalDesglose(iva) {

				return !iva ? Intl.NumberFormat("es-CL").format(this.total_desglose) : Intl.NumberFormat("es-CL").format(this.total_desglose_iva)
			},

			getTotalFolio(iva) {

				return !iva ? Intl.NumberFormat("es-CL").format(this.total_folio) : Intl.NumberFormat("es-CL").format(this.total_folio_iva)
			},

			getTotalPendiente(iva) {

				return !iva ? Intl.NumberFormat("es-CL").format(this.total_pendiente) : Intl.NumberFormat("es-CL").format(this.total_pendiente_iva)
			},

			// Evento para agregar un nuevo campo INGRESE MONTO en la ventana
			// Se activa cuando se presiona el icono de la izquierda "[[]" del Ingresa Monto
			onClickAgregarCampoEvent(id) {

				var cliente = this.buscarCliente(id)

				// Creamos el componente INGRESA MONTO, para agregar un nuevo campo en la ventana
				// El nuevo campo tiene el boton eliminar (parametro agregar = false)

				var component = Vue.extend(IngresaMonto)
				var o = new component({ propsData: { cliente: cliente, agregar: false } })
				o.$on("evento-eliminar-campo", this.onClickEliminarCampoEvent)
				o.$on("evento-agregar-glosa", this.onClickAgregarGlosaEvent)
				o.$mount()
				$("#" + id).append(o.$el)
			},

			// Si se elimina un objeto del "Ingresar Monto", se actualiza la lista de facturas y se recalculan los totales
			onClickEliminarCampoEvent(id) {

				// Eliminamos la factura asociada de la lista de facturas
				this.eliminarFactura(id)
				// Calculamos los totales nuevamente
				this.calculaTotales()
			},

			// Evento para mostrar la ventana Agregar Glosa
			// Se activa cuando se presiona el boton "+ Agregar" de la ventana Refacturacion
			onClickAgregarGlosaEvent(data) {

				this.cliente = this.buscarCliente(data.cliente)
				this.id_agregar_glosa = data.id
				this.factura = this.buscarFactura(data.id)
				this.mostrar_agregar_glosa = true
			},

			onCerrarAgregarGlosa(value) {

				this.mostrar_agregar_glosa = value
			},

			onAgregarGlosa(data) {
				
				// Si la factura existe, al eliminamos para que se actualicen los datos
				this.eliminarFactura(data.cid)

				// Agregamos la factura a la lista
				this.facturas.push(data)

				this.calculaTotales()
				this.mostrar_agregar_glosa = false
			}
		}
	}
</script>
<style scoped>

	.separador {
		margin-bottom: 5px;
	}
</style>